function triggerOk(suffix, restoreOrigin = false) {
    if (typeof(fbq) != "function") {
        return
    }

    let originalHref = location.href
    let originalTitle = document.title

    let indexOfQuestionMark = location.href.indexOf("?")
    let baseUrl = indexOfQuestionMark != -1 ? location.href.substring(0, indexOfQuestionMark) : location.href
    baseUrl = !baseUrl.endsWith("/") ? baseUrl + "/" : baseUrl
    let newUrl = baseUrl + suffix
    if (indexOfQuestionMark != -1) {
        newUrl += location.href.substring(indexOfQuestionMark)
    }

    history.pushState({}, suffix, newUrl)
    fbq('track', 'PageView')
    if (restoreOrigin) {
        setTimeout(function () {
            history.replaceState({}, originalTitle, originalHref)
        }, 1000)
    }
}

export const bpOk = (restoreOrigin = false) => {
    triggerOk("bp-ok-", restoreOrigin)
}

export const bpEventOk = (restoreOrigin = false) => {
    triggerOk("bp-event-ok-", restoreOrigin)
}